import { createInvestorOnFounder, deleteInvestorOnFounder, updateInvestorOnFounder } from 'api/founderPipeline.api';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { fetchAndSetInvestorData, fetchAndSetPipelineData } from 'components/views/FounderPipeline/_helpers/founderPipeline.resolvers';
import { getBaseTodos } from 'constants';
import { $view, $list, $form } from 'signals/global.signals';
import displayError from 'utils/displayError';
import displayNotification from 'utils/displayNotification';
import getSelectValue from 'utils/getSelectValue';

/* ------ CRUD EVENTS ------*/
export const handleSubmitCreatePipelineOnFounder = async () => {
  const selectedInvestor = getSelectValue($form.value.investorId);
  const [recordType, investorId] = selectedInvestor.split('-');

  const dealId = getSelectValue($form.value.dealId);

  // eslint-disable-next-line no-use-before-define
  const isInvestorInPipeline = checkIfInvestorInPipeline({
    dealId,
    investorId,
    recordType,
    data: $list.value.data,
  });

  if (isInvestorInPipeline) {
    displayNotification({
      message: 'Investor already in pipeline for this deal. Cannot add again.',
      variant: 'warning',
      title: 'Validation Error!',
    });
    return;
  }

  $view.update({
    isModalLoading: true,
  });
  try {
    const createData = {
      dealId,
      pipelineStatus: getSelectValue($form.value.pipelineStatus),
      amountInvested: $form.value.amountInvested,
      previouslyCommitted: $form.value.previouslyCommitted,
      todos: getBaseTodos(),
    };

    if (recordType === 'synced') {
      createData.orgIdInvestor = Number(investorId);
    } else {
      createData.unsyncedInvestorId = Number(investorId);
    }

    await createInvestorOnFounder(createData);
    handleHideModal();
    await fetchAndSetInvestorData();
  } catch (error) {
    displayNotification({
      message: error.message,
      variant: 'danger',
      title: 'Error!',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

export const handleSubmitEditInvestorOnFounder = async () => {
  $view.update({
    isModalLoading: true,
  });
  try {
    await updateInvestorOnFounder($form.value.id, {
      pipelineStatus: getSelectValue($form.value.pipelineStatus),
      amountInvested: $form.value.amountInvested,
      previouslyCommitted: $form.value.previouslyCommitted,
    });
    displayNotification({
      message: 'Investor updated successfully',
      type: 'success',
    });
    handleHideModal();
    await fetchAndSetPipelineData();
  } catch (error) {
    displayError({
      message: 'Failed to update investor. Please try again.',
      title: 'Update Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};

export const handleSubmitDeletePipelineOnFounder = async () => {
  $view.update({
    isModalLoading: true,
  });
  try {
    await deleteInvestorOnFounder($form.value.id);
    handleHideModal();
    await fetchAndSetPipelineData();
  } catch (error) {
    displayError({
      message: 'Failed to delete investor. Please try again.',
      title: 'Delete Error',
    });
  } finally {
    $view.update({
      isModalLoading: false,
    });
  }
};
/*

/* ------ HELPER FUNCTIONS ------*/
const checkIfInvestorInPipeline = ({ investorId, dealId, recordType, data }) => {
  let isInvestorInPipeline = false;
  data.forEach((pipelineItem) => {
    if (pipelineItem.dealId !== Number(dealId)) {
      return;
    }

    if (recordType === 'synced') {
      if (pipelineItem.orgIdInvestor === Number(investorId)) {
        isInvestorInPipeline = true;
      }
    } else if (pipelineItem.unsyncedInvestorId === Number(investorId)) {
      isInvestorInPipeline = true;
    }
  });
  return isInvestorInPipeline;
};
